import React from "react"

export default class EditorToolbar extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="editor-toolbars">
        <div style={this.props.style} className="editor-toolbar-wrapper">
          <div id={this.props.id} className="editor-toolbar"></div>
        </div>
      </div>
    );
  }
};
